// extracted by mini-css-extract-plugin
export default {"error_text_view":"textfilds_err_error_text_view__0spOm","error_text_box":"textfilds_err_error_text_box__LGZYs"};